"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const pit_operation_types_1 = require("./pit-operation.types");
const contractor_1 = require("services/master-data/contractor");
const pit_1 = require("services/master-data/pit");
const area_1 = require("services/master-data/area");
const brand_1 = require("services/master-data/brand");
const seam_1 = require("services/master-data/seam");
const pitOperation_1 = require("services/configuration/pitOperation");
const stockpile_1 = require("services/master-data/stockpile");
const getDataGrid = ({ dataStates, filterChild }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, pitOperation_1._getPitOperation)(dataStates, filterChild);
    if (response.isError) {
        dispatch({
            type: pit_operation_types_1.pitOperationTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            },
        });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError
                ? []
                : response.data.map((item) => {
                    return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date), status: item.is_active ? 'Active' : 'Inactive', expanded: false });
                }),
        };
        dispatch({ type: pit_operation_types_1.pitOperationTypes.SET_DATA_GRID, payload });
    }
});
const onExpand = ({ dataGrid }) => (dispatch) => {
    dispatch({ type: pit_operation_types_1.pitOperationTypes.ON_EXPAND_GRID, payload: { dataGrid } });
};
const closeError = () => (dispatch) => {
    dispatch({
        type: pit_operation_types_1.pitOperationTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false,
        },
    });
};
const onDataStateChange = (dataStates) => (dispatch) => {
    const payload = {
        dataStates,
    };
    dispatch({ type: pit_operation_types_1.pitOperationTypes.ON_PAGE_CHANGE, payload });
};
const onClickMutation = (payload) => (dispatch) => {
    dispatch({ type: pit_operation_types_1.pitOperationTypes.ON_MUTATION_CLICK, payload });
};
const onFilterChild = (payload) => (dispatch) => {
    dispatch({ type: pit_operation_types_1.pitOperationTypes.ON_FILTER_CHILD, payload });
};
const onSaveDataItem = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f;
    const { mutationMode } = payload;
    const dt = (_b = (_a = payload.dataItem) === null || _a === void 0 ? void 0 : _a.dataChild) === null || _b === void 0 ? void 0 : _b.map((i) => {
        if (i.dumptruck_id) {
            return i.dumptruck_id;
        }
        else
            return i.id;
    });
    const response = payload.mutationMode == 'add'
        ? yield (0, pitOperation_1._createPitOperation)({
            contractor_id: ((_d = (_c = payload.dataItem) === null || _c === void 0 ? void 0 : _c.contractor) === null || _d === void 0 ? void 0 : _d.id) || '',
            area_id: payload.dataItem.area.id || '',
            brand_id: payload.dataItem.seam.id_brand || '',
            excavator_id: payload.dataItem.excavator.id || '',
            excavator_id_before: payload.dataItem.excavator_id,
            pit_id: payload.dataItem.pit.id || '',
            seam_id: payload.dataItem.seam.id || '',
            dumptruck_id: dt,
            modified_by: payload.dataItem.modified_by,
            checkpoint_id: payload.dataItem.checkpoint.checkpoint_id || ''
        })
        : yield (0, pitOperation_1._editPitOperation)({
            id: payload.dataItem.id,
            contractor_id: ((_f = (_e = payload.dataItem) === null || _e === void 0 ? void 0 : _e.contractor) === null || _f === void 0 ? void 0 : _f.id) ||
                payload.dataItem.contractor_id,
            area_id: payload.dataItem.area.id || payload.dataItem.area_id,
            checkpoint_id: payload.dataItem.checkpoint.checkpoint_id || payload.dataItem.checkpoint_id,
            brand_id: payload.dataItem.seam.id_brand || payload.dataItem.brand_id,
            excavator_id: payload.dataItem.excavator.id || payload.dataItem.excavator_id,
            excavator_id_before: payload.dataItem.excavator_id,
            pit_id: payload.dataItem.pit.id || payload.dataItem.pit_id,
            seam_id: payload.dataItem.seam.id || payload.dataItem.seam_id,
            dumptruck_id: dt,
            modified_date: new Date(),
            modified_by: payload.dataItem.modified_by,
        });
    const dataItem = Object.assign(Object.assign({}, payload.dataItem), { id: response.data.id });
    const isSuccess = !response.isError;
    if (isSuccess)
        dispatch({
            type: pit_operation_types_1.pitOperationTypes.ON_SAVE_DATAITEM,
            payload: Object.assign(Object.assign({}, payload), { dataItem, mutationMode, isSuccess }),
        });
    else
        dispatch({
            type: pit_operation_types_1.pitOperationTypes.SET_ERROR,
            payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage }),
        });
});
const onDelete = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, pitOperation_1._deletePitOperation)({ id: payload.dataItem.id });
    const isSuccess = !response.isError;
    if (isSuccess)
        dispatch({
            type: pit_operation_types_1.pitOperationTypes.ON_DELETE,
            payload: Object.assign(Object.assign({}, payload), { isSuccess }),
        });
    else {
        dispatch({
            type: pit_operation_types_1.pitOperationTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            },
        });
    }
});
const onDeleteAll = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, pitOperation_1._deleteAllPitOperation)();
    if (!response.isError) {
        dispatch({
            type: pit_operation_types_1.pitOperationTypes.ON_DELETE_ALL_PIT_OPERATION,
            payload: response,
        });
    }
    else {
        dispatch({
            type: pit_operation_types_1.pitOperationTypes.SET_ERROR,
            payload: response,
        });
    }
});
const getDetail = ({ isExternal, contractor_name }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const newFilters = isExternal
        ? [
            { field: 'is_active', operator: 'eq', value: true },
            { field: 'coal_mining', operator: 'eq', value: true },
            { field: 'contractor_name', operator: 'eq', value: contractor_name },
        ]
        : [
            { field: 'is_active', operator: 'eq', value: true },
            { field: 'coal_mining', operator: 'eq', value: true },
        ];
    const contractorPayload = {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        total: 0,
        skip: 0,
        take: 100,
        sort: [{ field: 'contractor_name', dir: 'asc' }],
        filter: {
            logic: 'and',
            filters: newFilters,
        },
    };
    const responseContractor = yield (0, contractor_1.getMasterContractor)(contractorPayload);
    const responsePit = yield (0, pit_1._getMasterPit)(dataStates);
    const responseBrand = yield (0, brand_1._getBrandData)(dataStates);
    const dataContractor = responseContractor.data;
    const dataPit = responsePit.data;
    const dataBrand = responseBrand.data;
    dispatch({
        type: pit_operation_types_1.pitOperationTypes.GET_DETAIL,
        payload: {
            dataContractor,
            dataPit,
            dataBrand,
        },
    });
});
const getDetailArea = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _g, _h;
    const pit_id = (_h = (_g = payload.dataItem) === null || _g === void 0 ? void 0 : _g.pit) === null || _h === void 0 ? void 0 : _h.id;
    const responsePit = yield (0, area_1._getMasterArea)({
        skip: 0,
        take: 100,
        filter: {
            logic: 'and',
            filters: [
                { field: 'is_active', operator: 'eq', value: true },
                { field: 'id_pit', operator: 'uuid', value: pit_id === null || pit_id === void 0 ? void 0 : pit_id.toString() },
            ],
        },
        total: 0,
        sortable: false,
        filterable: false,
        reorderable: false,
        scrollable: 'scrollable',
    });
    const dataArea = responsePit.data;
    dispatch({
        type: pit_operation_types_1.pitOperationTypes.GET_AREA,
        payload: {
            dataArea,
        },
    });
});
const getDetailSeam = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _j, _k;
    const id_area = (_k = (_j = payload.dataItem) === null || _j === void 0 ? void 0 : _j.area) === null || _k === void 0 ? void 0 : _k.id;
    const responseArea = yield (0, seam_1._getMasterSeam)({
        skip: 0,
        take: 100,
        filter: {
            logic: 'and',
            filters: [
                { field: 'is_active', operator: 'eq', value: true },
                { field: 'id_area', operator: 'uuid', value: id_area === null || id_area === void 0 ? void 0 : id_area.toString() },
            ],
        },
        total: 0,
        sortable: false,
        filterable: false,
        reorderable: false,
        scrollable: 'scrollable',
    });
    const dataSeam = responseArea.data;
    dispatch({
        type: pit_operation_types_1.pitOperationTypes.GET_SEAM,
        payload: {
            dataSeam,
        },
    });
});
const getDetailCheckpoint = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, stockpile_1._getMasterStockpile)({
        skip: 0,
        take: 10000,
        filter: {
            logic: 'and',
            filters: [{ field: 'is_active', operator: 'eq', value: true }],
        },
        total: 0,
        sortable: false,
        filterable: false,
        reorderable: false,
        scrollable: 'scrollable',
        sort: [{ field: 'stockpile', dir: 'asc' }],
    });
    if (response.isError) {
        dispatch({
            type: pit_operation_types_1.pitOperationTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: 'Error Fetching Data Dropdown Master Silo. \n'.concat(response.errorMessage),
            },
        });
    }
    else {
        dispatch({
            type: pit_operation_types_1.pitOperationTypes.GET_CHECKPOINT,
            payload: {
                dataCheckpoint: response.isError
                    ? []
                    : response.data.map((item) => {
                        return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date), checkpoint_name: item.stockpile, checkpoint_id: item.id });
                    }),
            },
        });
    }
});
const getDetailExcavator = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const responseExcavator = yield (0, pitOperation_1._getPitExcavator)({
        contractor_id: payload.dataItem.contractor.id || '',
    });
    const dataExcavator = responseExcavator.data;
    dispatch({
        type: pit_operation_types_1.pitOperationTypes.GET_EXCAVATOR,
        payload: {
            dataExcavator,
        },
    });
});
const getDetailDumpTruck = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _l;
    const responseDumpTruck = yield (0, pitOperation_1._getPitDumpTruck)({
        contractor_id: payload.dataItem.contractor.id || '',
        excavator_id: payload.dataItem.excavator.id || '',
    });
    const dt = (_l = responseDumpTruck.data) === null || _l === void 0 ? void 0 : _l.filter((x) => {
        var _a, _b;
        return x.id ==
            ((_b = (_a = payload.dataItem.dataChild) === null || _a === void 0 ? void 0 : _a.find((y) => y.dumptruck_id == x.id)) === null || _b === void 0 ? void 0 : _b.dumptruck_id);
    });
    const newDataItem = Object.assign(Object.assign({}, payload.dataItem), { dataChild: dt.sort((a, b) => a.dumptruck_no > b.dumptruck_no ? 1 : -1) });
    const dataDumpTruck = responseDumpTruck.data.sort(({ dumptruck_no: a }, { dumptruck_no: b }) => Number(a) - Number(b));
    dispatch({
        type: pit_operation_types_1.pitOperationTypes.GET_DUMPTRUCK,
        payload: {
            dataDumpTruck,
            dataItem: newDataItem,
        },
    });
});
const onResetDumpTruck = () => (dispatch) => {
    dispatch({
        type: pit_operation_types_1.pitOperationTypes.RESET_DUMPTRUCK,
        payload: {
            dataDumpTruck: [],
        },
    });
};
const onFilterChange = (payload) => (dispatch) => {
    dispatch({ type: pit_operation_types_1.pitOperationTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = (payload) => (dispatch) => {
    dispatch({ type: pit_operation_types_1.pitOperationTypes.ON_SORT_CHANGE, payload });
};
const dataStates = {
    filterable: true,
    sortable: true,
    reorderable: false,
    scrollable: 'scrollable',
    skip: 0,
    take: 100,
    total: 0,
    filter: {
        logic: 'and',
        filters: [{ field: 'is_active', operator: 'eq', value: true }],
    },
};
exports.default = {
    onExpand,
    onDelete,
    getDetail,
    closeError,
    onDeleteAll,
    getDataGrid,
    onSortChange,
    onFilterChild,
    getDetailSeam,
    getDetailArea,
    onSaveDataItem,
    onFilterChange,
    onClickMutation,
    onResetDumpTruck,
    onDataStateChange,
    getDetailDumpTruck,
    getDetailExcavator,
    getDetailCheckpoint,
};
